
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

import InfoBlock from './components/InfoBlock.vue'
import CommentBlock from './components/CommentBlock.vue'

@Component({
  components: {
    InfoBlock,
    CommentBlock,
  },
})
export default class Member extends Vue {
  breadcrumbItems = [
    { label: '首頁', to: '/' },
    { label: '最新功能' },
    { label: '自助點餐Kiosk' }
  ]

  get isH5() {
    return AppModule.isH5
  }

  get images() {
    return [
      'https://spics.inctrip.com/e820eede71707388cfbb8af55fd8d9e8.png',
      'https://spics.inctrip.com/de46ba5d800fd949fc794806990ad097.png',
      'https://spics.inctrip.com/d468bc98ed43a62b8d6186145cd9f5bf.png',
      'https://spics.inctrip.com/f885279fc211394dceb0ae2ca454dc5c.png',
      'https://spics.inctrip.com/fd4115186621cbe78cd04dfb00395f36.png'
    ]
  }
}
